/**
 * Prikaz greške i troubleshooting koraka kada eID login ne uspe.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { APP_PATHS } from '@/shared/constants/routes';
import './LoginLaunchPage.css';

export const LOGIN_TROUBLESHOOTING_STEPS = [
  {
    title: '1. Отворите портал у Chrome или Edge прегледачу',
    text:
      'Пријава преко eUprava eID ради најсигурније у Google Chrome или Microsoft Edge. Уграђени прегледачи у Viber-у, Teams-у, Outlook-у или другим апликацијама не подржавају преусмеравање на eID.',
    steps: [
      'Ако сте дошли преко линка из неке апликације, копирајте адресу портала из адресне траке.',
      'Отворите Chrome или Edge и налепите адресу у нови прозор прегледача.',
      'Поново кликните на дугме за пријаву.',
    ],
  },
  {
    title: '2. Дозволите колачиће и податке сајта — Google Chrome',
    text:
      'Пре преусмеравања на eID, портал мора да сачува кратак безбедносни кључ у прегледачу. Ако су колачићи блокирани, пријава стаје.',
    steps: [
      'У адресној траци, лево од адресе, кликните на икону катанца или подешавања.',
      'Изаберите „Подешавања сајта" (Site settings).',
      'Код „Колачићи и подаци сајта" (Cookies and site data) изаберите „Дозволи" (Allow).',
      'Затворите прозор подешавања, освежите страницу (F5 или Ctrl+R) и покушајте пријаву поново.',
      'Ако не помаже: Chrome мени (три тачке, горе десно) → Подешавања → Приватност и безбедност → Колачићи и подаци других сајтова → Дозволи све колачиће.',
    ],
  },
  {
    title: '3. Дозволите колачиће и податке сајта — Microsoft Edge',
    text: 'Исти разлог као у Chrome-у — Edge мора сачувати безбедносни кључ пре преусмеравања.',
    steps: [
      'У адресној траци кликните на икону катанца или информација.',
      'Изаберите „Дозволе за овај сајт" (Permissions for this site).',
      'Код „Колачићи" поставите на „Дозволи" (Allow).',
      'Освежите страницу (F5) и покушајте пријаву поново.',
      'Ако не помаже: Edge мени (три тачке, горе десно) → Подешавања → Колачићи и дозволе сајта → Управљај дозволама → проверите да адреса портала није на листи блокираних.',
    ],
  },
  {
    title: '4. Прихватите обавештење о колачићима на порталу',
    text:
      'Ако на дну или врху странице постоји трака са питањем о колачићима, ово је кључно — одбијање колачића директно спречава покретање пријаве.',
    steps: [
      'Кликните на „Прихвати све" или „Прихвати" — немојте бирати „Само неопходни" јер eID пријава тада неће радити.',
      'Сачекајте да се трака затвори.',
      'Поново кликните на дугме за пријаву.',
    ],
  },
  {
    title: '5. Проверите да ли је прегледач нешто питао',
    text: 'Прегледач или проширење понекад прекине пријаву и чека вашу дозволу:',
    steps: [
      'Погледајте адресну траку — да ли је видљива икона (катанац, штит, оквир за обавештење)? Кликните је и одаберите „Дозволи" или „Allow".',
      'Ако је искочио прозор са питањем о преусмеравању, кликните „Дозволи" или „Настави".',
      'Ако имате инсталирано проширење за читач личне карте или eID, проверите да ли тражи потврду.',
      'Затворите све табове портала, отворите потпуно нови таб и поново покушајте пријаву.',
    ],
  },
  {
    title: '6. Safari на Mac рачунару',
    steps: [
      'У горњој траци изаберите Safari → Подешавања (Settings) → картица Приватност (Privacy).',
      'Искључите опцију „Спречи праћење са других сајтова" (Prevent cross-site tracking) привремено.',
      'Вратите се на портал, освежите страницу (Cmd+R) и покушајте пријаву.',
      'Алтернативно: у горњој траци Safari → Подешавања за [назив сајта] → код Колачићи изаберите „Дозволи".',
    ],
  },
  {
    title: '7. Safari на iPhone или iPad уређају',
    steps: [
      'Отворите системска „Подешавања" на уређају (не у Safari-ју).',
      'Пронађите и тапните на „Safari" у листи.',
      'Искључите прекидач „Спречи праћење са других сајтова" (Prevent Cross-Site Tracking).',
      'Вратите се у Safari, освежите страницу и покушајте пријаву.',
      'Важно: пријаву отворите директно у Safari-ју, не преко линка из неке апликације.',
    ],
  },
  {
    title: '8. Mozilla Firefox',
    steps: [
      'У адресној траци кликните на икону штита или катанца лево од адресе.',
      'Ако пише „Заштита: Строжа заштита" (Enhanced Tracking Protection: Strict), кликните „Искључи заштиту за овај сајт".',
      'Освежите страницу и покушајте пријаву.',
      'Ако не помаже: Firefox мени (три хоризонталне линије) → Подешавања → Приватност и безбедност → у секцији „Колачићи и подаци сајта" проверите да портал није међу блокираним.',
    ],
  },
  {
    title: '9. Блокатори реклама и друга проширења',
    steps: [
      'Кликните на икону ad blocker-а (нпр. uBlock Origin, AdBlock, AdGuard) у траци прегледача.',
      'Изаберите „Паузирај на овом сајту" или „Искључи за овај домен" и освежите страницу.',
      'Ако имате VPN проширење активирано у прегледачу, привремено га искључите и покушајте поново.',
      'Ако постоје друга сигурносна проширења (антивирус у прегледачу), и њих привремено искључите.',
    ],
  },
  {
    title: '10. Приватни / инкогнито прозор',
    text:
      'У приватном прозору колачићи и локални подаци се бришу одмах по затварању, а неке политике их потпуно онемогућавају. eID пријава не ради поуздано у инкогнито режиму.',
    steps: [
      'Затворите приватни / инкогнито прозор.',
      'Отворите обичан (нормалан) прозор Chrome, Edge или Firefox.',
      'Посетите портал и поново покушајте пријаву.',
    ],
  },
  {
    title: '11. Корпоративна мрежа, VPN и сигурносни сертификат',
    text: 'У државним институцијама и компанијама мрежна опрема понекад блокира eID сервер:',
    steps: [
      'Пробајте пријаву са мобилног интернета (хотспот са телефона) — ако успе, проблем је у мрежи.',
      'Ако прегледач приказује „Веза није безбедна" или упозорење о сертификату — не настављајте сами. Обратите се ИТ служби.',
      'Ако користите VPN, привремено га искључите и покушајте поново.',
      'Замолите ИТ подршку да провери да ли firewall или proxy блокирају приступ домену prijava.test.eid.gov.rs.',
    ],
  },
];

const LoginLaunchErrorView = () => (
  <section className="login-launch-page content-wrapper py-6" aria-labelledby="login-launch-error-title">
    <div className="login-launch-card login-launch-card--error">
      <div className="login-launch-icon" aria-hidden="true">
        <i className="fas fa-exclamation-triangle" />
      </div>
      <p className="login-launch-eyebrow">eUprava eID</p>
      <h1 id="login-launch-error-title" className="login-launch-title">
        Пријава није могла да се покрене
      </h1>
      <p className="login-launch-message">
        Веза са eUprava eID сервером није успостављена. Код већине корисника пријава ради
        без проблема — грешка је обично у подешавањима прегледача или мреже на овом
        уређају. Следите кораке у наставку, почевши од корака 1.
      </p>
      <section
        className="login-launch-troubleshooting"
        aria-labelledby="login-launch-troubleshooting-title"
      >
        <h2 id="login-launch-troubleshooting-title" className="login-launch-troubleshooting-title">
          Шта можете да урадите — корак по корак
        </h2>
        <ol className="login-launch-troubleshooting-list">
          {LOGIN_TROUBLESHOOTING_STEPS.map((step) => (
            <li key={step.title} className="login-launch-troubleshooting-item">
              <strong className="login-launch-troubleshooting-item-title">{step.title}</strong>
              {step.text ? (
                <p className="login-launch-troubleshooting-intro">{step.text}</p>
              ) : null}
              {step.steps?.length ? (
                <ol className="login-launch-troubleshooting-sublist">
                  {step.steps.map((substep) => (
                    <li key={substep}>{substep}</li>
                  ))}
                </ol>
              ) : null}
            </li>
          ))}
        </ol>
      </section>
      <p className="login-launch-message login-launch-message--note">
        Ако пријава и даље не ради, обратите се подршци. Наведите: прегледач и верзију
        (нпр. Chrome 124), уређај, да ли сте у пословној мрежи (VPN / proxy), и на ком
        кораку сте запели.
      </p>
      <div className="login-launch-actions">
        <Link
          to={APP_PATHS.AUTH.LOGIN}
          reloadDocument
          className="login-launch-link login-launch-link--primary"
        >
          <i className="fas fa-redo" aria-hidden="true" />
          Покушајте поново
        </Link>
        <Link to="/" className="login-launch-link login-launch-link--secondary">
          <i className="fas fa-arrow-left" aria-hidden="true" />
          Назад на почетну
        </Link>
      </div>
    </div>
  </section>
);

export default LoginLaunchErrorView;
